import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  GetCompany,
  GetProduct,
  PostLinkSupplier,
} from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";

const AddLinkSupplier = (props) => {
  const { selectedData, formType, setOpenDrawer, title, GetActiveData } = props;
  console.log("selectedData ---- ", selectedData);
  let formRef = useRef();
  const UserId = sessionStorage.getItem("UserId");
  const initialValues = {
    productId: "",
    companyId: "",
    supplierId: "",
  };

  const [companyDetails, setCompanyDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [refreshKey, setRefreshKey] = useState(1);

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const filteredData = res.data
        .map((item) => {
          if (item.isEnabled) {
            return {
              ...item,
              label: item?.shortName,
              value: item?._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(filteredData);
    });
  };

  const GetProductDetails = () => {
    GetProduct({ isAscending: true }).then((res) => {
      const filteredData = res.data
        .map((item) => {
          if (item.isEnabled && item.productId) {
            return {
              ...item,
              label: item?.productId + " (" + item?.product + ")",
              value: item?._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setProductDetails(filteredData);
    });
  };

  useEffect(() => {
    GetCompanyDetails();
    GetProductDetails();
    // if (formType === "view") {
    Object.keys(initialValues).forEach((el) => {
      initialValues[el] = selectedData[el];
      console.log("eeeeeeeeeeeeeee", selectedData[el]);
    });
    formRef.setFieldValue(initialValues);
    // }
  }, []);

  const onKeyDownHandler = (e, values) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit(e, values, "Save");
    }
  };

  const onSubmit = (e, data, keys) => {
    if (e.key === "Enter" || keys === "Save") {
      if (formType === "add") {
        data.createdBy = UserId;
      } else if (formType === "edit") {
        data.updatedBy = UserId;
        const UpdatedTime = new Date();
        data.updatedAt = UpdatedTime;
      }
      console.log("data -----------", data);
      PostLinkSupplier(data).then((res) => {
        if (!res) {
          setOpenDrawer(true);
        } else {
          setOpenDrawer(false);
          GetActiveData();
        }
      });
    } else if (keys === "Save&Create") {
      data.createdBy = UserId;
      PostLinkSupplier(data).then((res) => {
        if (res) {
          formRef.resetForm();
          setRefreshKey(refreshKey + 1);
        }
        GetActiveData();
      });
    }
  };

  return (
    <>
      <div className="DrawerContainer">
        <Grid container className="DrawerHeader">
          <Grid item xs={10} sm={10}>
            <Typography>{title} Link Supplier</Typography>
          </Grid>
          <Grid item xs={2} sm={2} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => setOpenDrawer(false)}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          innerRef={(ref) => {
            if (ref) {
              formRef = ref;
            }
          }}
        >
          {({ values, setFieldValue }) => (
            <Form onKeyDown={(e) => onKeyDownHandler(e, values)}>
              <div className={Styles.addContent}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    {/* test */}
                    {/* <FloatLabel label="Product Id" value={values.productId}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Product Id
                    </Typography>
                      <Autocomplete
                        name="productId"
                        className="AutoComplete_InputBox w-100"
                        onChange={(option, value) => {
                          setFieldValue("productId", value._id);
                        }}
                        value={
                          selectedData?.productData
                            ? `${selectedData.productData.productId} (${selectedData.productData.product})`
                            : ""
                        }
                        disabled={formType === "view"}
                        options={productDetails}
                        renderInput={(params) => (
                        <TextField
                        {...params}
                        placeholder="Select Product Id"
                        />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option?._id === value?._id
                        }
                        key={refreshKey}
                      />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="Supplier Id" value={values.supplierId}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Supplier Id
                    </Typography>
                      <Field
                        name="supplierId"
                        className="InputFiled"
                         placeHolder="Enter Supplier Id"
                        style={{ textTransform: "uppercase" }}
                        disabled={formType === "view" ? true : false}
                        key={refreshKey}
                      />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="Supplier Name" value={values.companyId}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Supplier Name
                    </Typography>
                      <Autocomplete
                        name="companyId"
                        className="AutoComplete_InputBox w-100"
                        value={selectedData?.companyData?.shortName || ""}
                        onChange={(option, value) => {
                          setFieldValue("companyId", value._id);
                        }}
                        // disabled={formType === "view"}
                        options={companyDetails}
                        renderInput={(params) => (
                          <TextField
                          {...params}
                          placeholder="Select Supplier Name"
                          />
                          )}
                        isOptionEqualToValue={(option, value) =>
                          option?._id === value?._id
                        }
                        key={refreshKey}
                      />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: formType === "view" ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Created Date
                    </Typography>
                    {/* <FloatLabel label="Created Date" value={"react"}> */}
                      <Field
                        name="createdAt"
                        className="InputFiled"
                        disabled={formType === "view" ? true : false}
                        value={selectedData?.createdAt ? moment(selectedData.createdAt, "DD/MM/YYYY hh:mm A").format("DD/MM/YYYY hh:mm A") : ""}
                      />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: formType === "view" ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Updated Date
                    </Typography>
                    {/* <FloatLabel label="Updated Date" value={"react"}> */}
                      <Field
                        name="updatedAt"
                        className="InputFiled"
                        disabled={formType === "view" ? true : false}
                        style={{ textTransform: "uppercase" }}
                        value={selectedData?.updatedAt ? moment(selectedData.updatedAt, "DD/MM/YYYY hh:mm A").format("DD/MM/YYYY hh:mm A") : ""}
                      />
                    {/* </FloatLabel> */}
                  </Grid>
                </Grid>
              </div>
              <div className="Dialog_Footers">
              <div className="Dialog_Button_Groups">
                <Button
                  onClick={() => setOpenDrawer(false)}
                  className="Dialog_Cancels"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={(e) => onSubmit(e, values, "Save")}
                  className="Dialog_Saves"
                  sx={{ display: formType === "view" ? "none" : "block",  
                   }}
                >
                  {selectedData?._id ? "Update" : "Save & Exit"}
                </Button>
                </div>
                <Button
                  sx={{ display: formType === "add" ? "block" : "none",
                    marginLeft: "10px",  
                   }}
                  className="Dialog_Save_Exits"
                  onClick={(e) => onSubmit(e, values, "Save&Create")}
                >
                  Save & Create New
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AddLinkSupplier;
